import { BadgeCheck, Leaf, MapPin } from "lucide-react";
import { ABOUT_IMAGE } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const NUMBERS = [
  { value: "20", label: "Regioni coperte" },
  { value: "350+", label: "Clienti attivi" },
  { value: "98%", label: "Contratti rinnovati" },
];

const CERTS = ["ISO 9001", "ISO 14001", "HACCP", "D.Lgs 81/08"];

const AboutSection = () => (
  <section id="chi-siamo" className="bg-white py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal className="relative">
        <div className="absolute -bottom-4 -right-4 h-full w-full rounded-[2rem] border-2 border-[#00B36B]/25" />
        <div className="relative overflow-hidden rounded-[2rem]">
          <img
            src={ABOUT_IMAGE}
            alt="Specialista Clario durante un intervento di precisione"
            loading="lazy"
            className="h-[420px] w-full object-cover lg:h-[520px]"
          />
        </div>
        <div className="absolute -top-5 left-6 rounded-2xl border border-slate-100 bg-white px-5 py-4 shadow-xl">
          <p className="flex items-center gap-2 text-sm font-bold text-slate-900">
            <MapPin className="h-4 w-4 text-[#00B36B]" />
            Nord · Centro · Sud
          </p>
          <p className="mt-1 text-xs text-slate-500">Squadre operative in tutta Italia</p>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#009E5E]">
            Chi siamo
          </span>
          <h2 className="mt-3 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Nati per rendere il pulito{" "}
            <span className="font-serif-accent font-medium text-[#00B36B]">una certezza</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-600">
            Clario è nata per trasformare il settore del cleaning in un servizio affidabile,
            puntuale e tecnologicamente gestito. Operiamo su tutto il territorio nazionale con
            team dislocati in Nord, Centro e Sud Italia, un unico standard qualitativo e un
            referente dedicato per ogni cliente.
          </p>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Utilizziamo esclusivamente detergenti ecologici certificati e presidi
            medico-chirurgici registrati, con personale assunto e formato secondo il D.Lgs 81/08.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-8 grid grid-cols-3 gap-4">
            {NUMBERS.map((n) => (
              <div
                key={n.label}
                className="rounded-2xl border border-slate-100 bg-[#F9FAFB] p-4 text-center"
              >
                <p className="text-2xl font-extrabold text-[#00B36B] sm:text-3xl">{n.value}</p>
                <p className="mt-1 text-xs font-semibold text-slate-500">{n.label}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-7 flex flex-wrap gap-2.5">
            {CERTS.map((c) => (
              <span
                key={c}
                className="inline-flex items-center gap-1.5 rounded-full border border-[#00B36B]/25 bg-[#E8F8F0] px-4 py-1.5 text-xs font-bold text-[#009E5E]"
              >
                <BadgeCheck className="h-3.5 w-3.5" />
                {c}
              </span>
            ))}
            <span className="inline-flex items-center gap-1.5 rounded-full border border-[#00B36B]/25 bg-[#E8F8F0] px-4 py-1.5 text-xs font-bold text-[#009E5E]">
              <Leaf className="h-3.5 w-3.5" />
              Detergenti ecologici
            </span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default AboutSection;
